/* src/components/utils/exportUtils.js - Modificado el 04-02-2026 */
/* ------------ exportaciones estándar (PDF/CSV) ---------------- */

import api from "../../services/api.js";

/* ---------------------------------------------------------- */
/* ✅ Abrir PDF desde Blob                                    */
/* ---------------------------------------------------------- */
export const openPdfBlob = (data) => {
  if (!data) return;

  const blob = new Blob([data], {
    type: "application/pdf",
  });

  const url = window.URL.createObjectURL(blob);
  window.open(url, "_blank");

  setTimeout(() => {
    window.URL.revokeObjectURL(url);
  }, 1500);
};

/* ---------------------------------------------------------- */
/* ✅ Descargar archivo genérico desde Blob                    */
/* ---------------------------------------------------------- */
export const downloadBlob = (data, filename) => {
  if (!data) return;

  const blob = new Blob([data]);
  const url = window.URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", filename);

  document.body.appendChild(link);
  link.click();
  link.remove();

  window.URL.revokeObjectURL(url);
};

/* ---------------------------------------------------------- */
/* ✅ Descargar CSV desde Blob con MIME correcto               */
/* ---------------------------------------------------------- */
export const downloadCsvBlob = (data, filename) => {
  const blob = new Blob([data], {
    type: "text/csv;charset=utf-8;",
  });

  downloadBlob(blob, filename);
};

/* ---------------------------------------------------------- */
/* ✅ Export PDF Async Overwatch (BullMQ Job Polling)          */
/* ---------------------------------------------------------- */
/*
  endpointBase ejemplo: "/subircarpeta/pdf"

  Flujo:
   1) POST → devuelve jobId
   2) GET  → 202 mientras no esté listo
   3) GET  → PDF Blob final
*/
export const exportPdfAsync = async ({
  endpointBase,
  payload,
  onStart,
  onFinish,
  onError,
  timeoutMs = 30000,
  pollIntervalMs = 1500,
}) => {
  let intervalId;
  let timeoutId;

  try {
    onStart?.();

    /* 1️⃣ Encolar Job */
    const { data } = await api.post(endpointBase, payload);

    const { jobId } = data;
    if (!jobId) throw new Error("JobId no recibido desde backend");

    /* 2️⃣ Polling */
    intervalId = setInterval(async () => {
      try {
        const response = await api.get(`${endpointBase}/${jobId}`, {
          responseType: "blob",
        });

        const contentType = response.headers["content-type"];

        if (!contentType?.includes("application/pdf")) {
          return;
        }

        openPdfBlob(response.data);

        clearInterval(intervalId);
        clearTimeout(timeoutId);

        onFinish?.();
      } catch (err) {
        if (err?.response?.status !== 202) {
          throw err;
        }
      }
    }, pollIntervalMs);

    /* 3️⃣ Timeout seguridad */
    timeoutId = setTimeout(() => {
      clearInterval(intervalId);

      onError?.("El reporte está tardando más de lo esperado");
    }, timeoutMs);
  } catch (error) {
    clearInterval(intervalId);
    clearTimeout(timeoutId);

    onError?.("No fue posible generar el reporte");
  }
};
